const baseURL = process.env.REACT_APP_URL_PROPIEDADES;

export const getSummary = async (userEmail: string) => {
    const queryParams = `email=${encodeURIComponent(userEmail)}`
    const requestOptions = {
        method: 'GET'
    };
    const urlRequest = `${baseURL}/api/v3/property/propertiesSummary?${queryParams}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const getDisabledSummary = async () => {
    const requestOptions = {
        method: 'GET'
    };
    const urlRequest = `${baseURL}/api/v3/property/propertiesDisabledSummary`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
}

export const getMoreInfoMigrateSummary = async () => {
    const requestOptions = {
        method: 'GET'
    };
    const urlRequest = `${baseURL}/api/v3/property/propertiesMoreInfoMigrateSummary`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
}


export const basicInformation = async (property_ids: string, email: string) => {
    const queryParams = `property_ids=${encodeURIComponent(property_ids)}&email=${email}`
    const requestOptions = {
        method: 'GET'
    };
    const urlRequest = `${baseURL}/api/v3/property/BasicInformation?${queryParams}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const basicInformationContact = async (property_ids: string, email: string) => {
    const queryParams = `property_ids=${encodeURIComponent(property_ids)}&email=${email}`
    const requestOptions = {
        method: 'GET'
    };
    const urlRequest = `${baseURL}/api/v3/property/BasicInformationContact?${queryParams}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const extendValidity = async (property_ids: number[]) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            property_ids: property_ids
        })
    };
    const urlRequest = `${baseURL}/api/v3/property/extendProperties`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const getUserEmailContactSummary = async (userEmail: string) => {
    const queryParams = `email=${encodeURIComponent(userEmail)}`
    const requestOptions = {
        method: 'GET'
    };
    const urlRequest = `${baseURL}/api/v3/property/propertiesSummaryContact?${queryParams}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const getBannedUsers = async (userEmail: string, feedName: string, token: string) => {
    const queryParams = `email=${encodeURIComponent(userEmail)}&feed_name=${encodeURIComponent(feedName)}&country=MX`
    const requestOptions = {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_ADMINISTRATION_XAPIKEY,
            'Authorization': `Bearer ${token}`
        }
    };
    const urlRequest = `${process.env.REACT_APP_ADMINISTRATION_API_URL}get_banned_users?${queryParams}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};
